import http, {configForm} from "../config/http-configs";
import {configJson} from "@/api/config/http-configs";


export const visitorAdd = (name, tel, company, ic, nationality) => {
    const url = "/mobile/visitor/company/add"
    const postData = {name, tel, company, ic, nationality}
    return http.post(url, postData, configJson)
}

// visitorCodes [visitorCode1, visitorCode2]
export const getVisitorByBatch = (visitorCodes) => {
    const url = `/mobile/visitor/list?visitorCodes=${visitorCodes}`
    return http.post(url, null, configForm)
}

export const mobileUpdateVisitor = (visitor) => {
    const url = "/mobile/visitor/scene/update"
    return http.post(url, visitor, configJson)
}

export const mobileAddVisitorBatch = (visitorList) => {
    const url = "/mobile/visitor/scene/add"
    return http.post(url, visitorList, configJson)
}

export const searchVisitor = (searchData) => {
    const url = `/mobile/visitor/search`
    return http.post(url, searchData, configJson)
}
